<div class="container-fluid p-3">
  <!-- Formulario -->
  <mat-card>
    <mat-card-header class="pb-0">
      <mat-card-title>{{ isEditing ? 'Editar' : 'Crear' }} ajuste de valor</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <form [formGroup]="ajusteForm" (ngSubmit)="onSubmit()">
        <div class="row g-3 align-items-center">
          <!-- Periodo -->
          <div class="col-md-2 col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Periodo</mat-label>
              <mat-select formControlName="periodo" [disabled]="isEditing" [matTooltip]="isEditing ? 'No se puede modificar el periodo en modo edición' : ''" [matTooltipPosition]="'above'">
                <mat-option *ngFor="let periodo of periodosAbiertos" [value]="periodo.periodo">
                  {{periodo.periodo}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ajusteForm.get('periodo')?.hasError('required')">
                El periodo es requerido
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-3 col-sm-12 ">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Concepto</mat-label>
              <mat-select formControlName="concepto">
                <mat-option *ngFor="let concepto of conceptos" [value]="concepto.codigo">
                  {{concepto.codigo}} - {{concepto.descripcion}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ajusteForm.get('concepto')?.hasError('required')">
                Este campo es requerido
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-5 col-sm-12 ">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Vendedor</mat-label>
              <input type="text" matInput [formControl]="vendedorControl" [matAutocomplete]="auto"
              [readonly]="isEditing" [matTooltip]="isEditing ? 'No se puede modificar el vendedor en modo edición' : ''"
              [matTooltipPosition]="'above'">
              <button mat-icon-button matSuffix (click)="mostrarTodosLosVendedores()" type="button" [disabled]="isEditing"
              [matTooltip]="isEditing ? 'No se puede modificar el vendedor en modo edición' : ''">
                <mat-icon>search</mat-icon>
              </button>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayVendedor">
                <mat-option *ngFor="let vendedor of vendedoresFiltrados | async" [value]="vendedor">
                  {{vendedor.codigo_vendedor}} - {{vendedor.nombre_vendedor}}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="vendedorControl.hasError('required')">
                Este campo es requerido
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-2 col-sm-12 ">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Valor</mat-label>
              <input matInput type="text" formControlName="valor" required
                [value]="ajusteForm.get('valor')?.value | currency:'COP':'symbol-narrow':'1.0-0'"
                (input)="onValorInput($event)">
              <mat-error *ngIf="ajusteForm.get('valor')?.hasError('required')">
                Este campo es requerido
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="d-flex gap-2 mt-3 justify-content-end">
          <button mat-flat-button color="primary" type="submit" [disabled]="!ajusteForm.valid || isLoading" class="btn btn-primary">
            {{ isEditing ? 'Actualizar' : 'Guardar' }}
          </button>
          <button mat-flat-button *ngIf="isEditing" type="button" (click)="cancelarEdicion()" class="btn btn-secondary" [disabled]="isLoading">
            Cancelar
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card class="mt-3">
    <mat-card-header class="pb-0">
      <mat-card-title>Lista de Ajustes</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <div class="row mb-3">
        <div class="col-md-4 col-sm-12 mb-2 mb-sm-0">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Buscar</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Buscar en registros" #input>
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>

        <div class="col-md-3 col-sm-12 mb-2 mb-sm-0">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Filtrar por Periodo</mat-label>
            <mat-select [(ngModel)]="periodoFiltro" (ngModelChange)="applyPeriodoFilter()">
              <mat-option value="">Todos los periodos</mat-option>
              <mat-option *ngFor="let periodo of periodos" [value]="periodo.periodo">
                {{periodo.periodo}} ({{periodo.estadoperiodo}})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="table w-100">
        <!-- Periodo Column -->
        <ng-container matColumnDef="periodo">
          <th mat-header-cell *matHeaderCellDef style="width: 15%; font-size: 11px;">Periodo</th>
          <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
            {{element.periodo}}
            <mat-icon *ngIf="!isPeriodoAbierto(element.periodo)" 
                     matTooltip="Periodo cerrado"
                     class="text-warning" 
                     style="font-size: 16px; height: 16px; width: 16px; margin-left: 4px; vertical-align: middle;">
              lock
            </mat-icon>
          </td>
        </ng-container>

        <!-- Concepto Column -->
        <ng-container matColumnDef="concepto">
          <th mat-header-cell *matHeaderCellDef style="width: 25%; font-size: 11px; ">Concepto</th>
          <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
            {{getConceptoDescripcion(element.concepto)}}
          </td>
        </ng-container>

        <!-- Vendedor Column -->
        <ng-container matColumnDef="c_ven">
          <th mat-header-cell *matHeaderCellDef style="width: 40%; font-size: 11px; ">Vendedor</th>
          <td mat-cell *matCellDef="let element" style="vertical-align: middle;font-size: 11px;">{{getVendedorNombre(element.c_ven)}}</td>
        </ng-container>

        <!-- Valor Column -->
        <ng-container matColumnDef="valor">
          <th mat-header-cell *matHeaderCellDef style="width: 20%; font-size: 11px; ">Valor</th>
          <td mat-cell *matCellDef="let element" [ngClass]="{'text-danger': element.valor < 0}" style="vertical-align: middle; font-size: 11px;">
            {{element.valor | currency:'COP':'symbol-narrow':'1.0-0'}}
          </td>
        </ng-container>

        <!-- Acciones Column -->
        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef style="width: 15%; text-align: center; font-size: 11px;">Acciones</th>
          <td mat-cell *matCellDef="let element" style="vertical-align: middle;">
            <div style="display: flex; justify-content: center; gap: 4px;">
              <button mat-icon-button 
                      [disabled]="!isPeriodoAbierto(element.periodo)"
                      (click)="editarAjuste(element)"
                      [matTooltip]="isPeriodoAbierto(element.periodo) ? 'Editar' : 'No se puede editar un registro de un periodo cerrado'">
                <mat-icon [ngClass]="{'text-dark': isPeriodoAbierto(element.periodo)}">edit</mat-icon>
              </button>
              <button mat-icon-button 
                      [disabled]="!isPeriodoAbierto(element.periodo)"
                      (click)="eliminarAjuste(element)"
                      [matTooltip]="isPeriodoAbierto(element.periodo) ? 'Eliminar' : 'No se puede eliminar un registro de un periodo cerrado'">
                <mat-icon [ngClass]="{'text-dark': isPeriodoAbierto(element.periodo)}">delete</mat-icon>
              </button>
              <button mat-icon-button (click)="verDetalles(element)" matTooltip="Ver detalles">
                <mat-icon class="text-dark">info</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="5">No se encontraron registros</td>
        </tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 25, 50]" [pageSize]="10" showFirstLastButtons></mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
</div>